import throughShipmentApi from "@api/throughShipment/throughShipmentApi";
import InfiniteScrollSelect from "@component/Common/InfiniteScrollSelect";
import { ContractType, regionTypeOptions } from "@constant/ThroughShipment";
import { dealerState, fetchRetailRegion, setDealerFilter } from "@redux/dealerSlice";

import React, { useEffect } from "react";
import { Button, Col, Form, Row, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

const Wrapper = styled(Form)<{ isVisible: boolean }>`
  padding: 24px 0px 0px 16px;
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
`;
const CustomButton = styled(Button)`
  margin-right: 10px;
`;

type Props = {
  isVisible: boolean;
};

export default function DealerFilter(props: Props) {
  const { isVisible } = props;

  const dispatch = useDispatch();
  const { retailRegion, dealerFilter } = useSelector(dealerState);

  const [form] = Form.useForm();
  const regionTypeValue = Form.useWatch("regionType", form);

  const onReset = () => {
    form.resetFields();
    dispatch(
      setDealerFilter({
        ...dealerFilter,
        regionType: undefined,
        regionName: undefined,
        contractType: undefined,
        retailer: undefined,
      }),
    );
  };

  const onSubmit = (values: any) => {
    dispatch(setDealerFilter({ ...dealerFilter, ...values }));
  };

  useEffect(() => {
    dispatch(fetchRetailRegion({}));
  }, [dispatch]);

  return (
    <Wrapper
      colon={false}
      labelAlign="left"
      labelCol={{ span: 10 }}
      form={form}
      isVisible={isVisible}
      initialValues={{}}
      onFinish={onSubmit}
    >
      <Row gutter={30}>
        <Col span={6}>
          <Form.Item label="合作通路類型" name="regionType" wrapperCol={{ span: 18 }}>
            <Select options={regionTypeOptions} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="通路名稱" name="retailer" wrapperCol={{ span: 18 }}>
            <InfiniteScrollSelect
              allowClear
              placeholder="請選擇"
              fetchListApi={(params) =>
                throughShipmentApi.fetchRetailList({
                  ...params,
                  ...(regionTypeValue ? { regionTypes: regionTypeValue } : {}),
                })
              }
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="地區" name="regionName" wrapperCol={{ span: 18 }}>
            <Select
              placeholder="請選擇"
              options={retailRegion.results.map((item) => ({ value: item.name, label: item.name }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={30}>
        <Col span={6}>
          <Form.Item label="合作模式" name="contractType" wrapperCol={{ span: 18 }}>
            <Select
              placeholder="請選擇"
              options={[
                { value: ContractType.BUYOUT_REFUNDABLE, label: "買斷可退" },
                { value: ContractType.BUY_AND_NOT_RETURN, label: "買斷不可退" },
                { value: ContractType.CONSIGNMENT, label: "寄倉" },
                { value: ContractType.TRANSFER, label: "轉單" },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={18}>
          <Row justify="end">
            <CustomButton onClick={onReset}>清除篩選條件</CustomButton>
            <Button type="primary" htmlType="submit">
              套用
            </Button>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
}
